import { colors } from '../../colors';
var pencilBanner = {
  bgColor: colors.white,
  textColor: colors.slateGreen,
  textColorDark: colors.ash,
  textColorLight: colors.white
};
export default pencilBanner;